import type { ComponentProps } from "react";

import { Field, PasswordInput, type FieldClassNames } from "@eisox/design-system";

import { useFieldContext } from "../form.context";
import { FieldErrors } from "./field-errors.component";

interface PasswordFieldProps extends Omit<ComponentProps<typeof PasswordInput>, "className"> {
  label?: string;
  description?: string;
  classNames?: FieldClassNames;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  label,
  description,
  classNames,
  children,
  onChange,
  onBlur,
  ...props
}) => {
  const field = useFieldContext<string | number | undefined>();

  return (
    <Field.Root className={classNames?.root}>
      <Field.Label className={classNames?.label}>{label}</Field.Label>
      <Field.Description className={classNames?.description}>{description}</Field.Description>
      <Field.Control
        render={
          <PasswordInput
            {...props}
            className={classNames?.control}
            value={field.state.value ?? ""}
            onChange={event => {
              field.handleChange(event.target.value);
              onChange?.(event);
            }}
            onBlur={event => {
              field.handleBlur();
              onBlur?.(event);
            }}
          >
            {children}
          </PasswordInput>
        }
      />
      <FieldErrors className={classNames?.error} />
    </Field.Root>
  );
};

export { PasswordField };
export type { PasswordFieldProps };
